import React from 'react';
import { useNavigate, Link, useLocation} from 'react-router'
import { useState } from 'react';



import Col from 'react-bootstrap/Col';
import { FaRegCircleUser } from "react-icons/fa6";
import { FaRegClipboard } from "react-icons/fa";
import { MdAddCircleOutline } from "react-icons/md";
import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';


const AccountSidebar = ({customerProfile}) => {  
    const navigate = useNavigate(); 
   const location = useLocation();

    return (
        <Col lg={3}>
            <div className='card shadow userNav mb-3'>
                {
                    customerProfile ? <div className='d-flex p-3 info align-items-center'>
                                        <img src={customerProfile.profile_picture} className='d-block' />
                                        <div className='ps-2'>
                                            <h5>{customerProfile.full_name}</h5>
                                            <p>Member</p>
                                        </div>                                
                                    </div>
                                    : ''
                }
                <ul className='nav d-flex flex-lg-column'>
                    <li className={location.pathname === "/update-profile" ? "active" : ""}><Link to={`/update-profile`}><FaRegCircleUser /> My Profile</Link></li>
                    <li className={location.pathname === "/post-ad/step1" ? "active" : ""}><Link to={`/post-ad/step1`}><MdAddCircleOutline /> Post a Ads</Link></li>
                    <li className={location.pathname === "/properties" ? "active" : ""}><Link to={`/properties`}><FaRegClipboard /> Properties</Link></li>
                </ul>
            </div>
        </Col>
    )
}

function mapStateToProps(state) {
    return {
        customerProfile: state.customer.customerProfile
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
          signUp: (post) => dispatch(actions.signUp(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(AccountSidebar);